export default __webpack_public_path__ + "static/media/Home_IMG-Civil.2b5a5e82.png";